/**
 * Module Dependencies
 */
import state from './state.js'
import newText from './new-text'
import getters from './getters.js'
import actions from './actions.js'
import newTable from './new-table'
import mutations from './mutations.js'
import newGenTable from './new-gen-table'
import newComponent from './new-component'
import imageUploader from './image-uploader'
import newCompset from './new-compset'

/**
 * War Room Module Declaration
 *
 * @type {Object}
 */
const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules: {
        newText,
        newTable,
        newGenTable,
        newComponent,
        imageUploader,
        newCompset
    }
}

export default module



// WEBPACK FOOTER //
// ./src/state/modules/dom/index.js